import React, { Suspense } from 'react';
import { Loading } from '@/components/common';

export const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<Loading fullScreen />}>{children}</Suspense>
);
